/* eslint-disable import/prefer-default-export */
export class UnexpectedError extends Error {
  constructor() {
    super(
      'We ran into an unexpected error. Please submit a request via https://whoopinc.typeform.com/to/XmzituEp to help get this resolved.',
    );
  }
}
